import { useToggle } from '../../hooks';
import { Icons } from '../Icons';

export const PasswordField = ({ value }: { value: string }) => {
  const passwordVisibility = useToggle();

  return (
    <div className="flex items-center gap-xl">
      {passwordVisibility.visible
        ? value
        : value.length > 0
          ? value
              .split('')
              .map(() => '•')
              .join('')
          : '-'}
      {passwordVisibility.visible ? (
        <Icons.Eye
          className="size-4 cursor-pointer"
          onClick={passwordVisibility.hide}
        />
      ) : (
        <Icons.EyeOff
          className="size-4 text-fg-tertiary cursor-pointer hover:text-fg-tertiary-hover transition"
          onClick={passwordVisibility.show}
        />
      )}
    </div>
  );
};
